export const META_KEY_NAME = '__meta' as const;

export const objectWithMeta = <
  O extends Record<PropertyKey, any>,
  M extends Record<PropertyKey, any>
>(
  object: O,
  meta: M
) => ({
  ...object,
  [META_KEY_NAME]: meta,
});

export const getMeta = <
  O extends { [META_KEY_NAME]?: Record<PropertyKey, any> }
>({
  [META_KEY_NAME]: meta,
}: O) => meta;

export const objectWithoutMeta = <
  O extends { [META_KEY_NAME]?: Record<PropertyKey, any> }
>({
  [META_KEY_NAME]: meta,
  ...rest
}: O) => rest;
